var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoodAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.625C12.1704 23.625 10.8538 23.3631 9.62533 22.8543C8.39691 22.3455 7.28074 21.5996 6.34054 20.6595C5.40035 19.7193 4.65455 18.6031 4.14572 17.3747C3.63689 16.1462 3.375 14.8296 3.375 13.5C3.375 12.1704 3.63689 10.8538 4.14572 9.62533C4.65455 8.39691 5.40035 7.28074 6.34054 6.34054C7.28074 5.40035 8.39691 4.65455 9.62533 4.14572C10.8538 3.63689 12.1704 3.375 13.5 3.375C16.1853 3.375 18.7606 4.44174 20.6595 6.34054C22.5583 8.23935 23.625 10.8147 23.625 13.5C23.625 16.1853 22.5583 18.7606 20.6595 20.6595C18.7606 22.5583 16.1853 23.625 13.5 23.625Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00146 10.125L11.2515 11.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0015 10.125L15.7515 11.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.314 18.0568C15.9474 17.6826 15.5098 17.3854 15.0268 17.1825C14.5439 16.9795 14.0253 16.875 13.5015 16.875C12.9776 16.875 12.459 16.9795 11.9761 17.1825C11.4932 17.3854 11.0556 17.6826 10.689 18.0568",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodAngry);
export default __webpack_public_path__ + "static/media/mood-angry.7538b9eff0d3920d2231b7c0db3bc71b.svg";
export { ForwardRef as ReactComponent };